import { createContext, ReactNode, useContext, useMemo, useState } from "react";


interface WorkflowSelectedGroupContextType {
  selectedGroupId: string | null;
  setSelectedGroupId: (groupId: string | null) => void;
}


const WorkflowSelectedGroupContext = createContext<WorkflowSelectedGroupContextType | null>(null);


export function WorkflowSelectedGroupProvider({ children }: { children: ReactNode }) {
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null);

  const values = useMemo(() => ({
    selectedGroupId,
    setSelectedGroupId,
  }), [selectedGroupId]);
  return (
    <WorkflowSelectedGroupContext.Provider
      value={values}
    >
      {children}
    </WorkflowSelectedGroupContext.Provider>
  );
}


export function useWorkflowSelectedGroupId() {
  const context = useContext(WorkflowSelectedGroupContext);
  if (!context) {
    throw new Error("useWorkflowSelectedGroupId must be used within WorkflowSelectedGroupProvider");
  }
  return context;
}
